import { Grid, IconButton, Stack, TextField, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useRequest } from "ahooks";
import React, { memo, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { IoCloseCircle } from "react-icons/io5";
import * as yup from "yup";
import moment from "moment";
import { useRecoilValue } from "recoil";
import { toast } from "react-toastify";
import { ControllDatePicker, ControlSelect, PrimaryModal } from "../../../components";
import { membershipDuration, membershipPaymentMethod } from "../../../constants/membership";
import MembershipDB from "../../../hooks/model/membership";
import { convertDurationToExpireDate } from "../../../utils/membership";
import { User as UserAuth } from "../../../recoils";
import useGetMemberByStudent from "../../../hooks/useGetMemberByStudent";
import MembershipIcon from "../../membership/MembershipIcon";

const initialState = {
  duration: "",
  payment_method: "",
  expire_at: null,
  date: null,
  start_date: null,
  amount: 0,
};

const schema = yup
  .object({
    duration: yup.string().required("Duration is required!"),
    payment_method: yup.string().required("Payment method is required!"),
    amount: yup.number().required("Amount is required!"),
    date: yup.string().nullable().required("Date is required!"),
    start_date: yup.string().nullable().required("Start date is required!"),
  })
  .required();
// initialDate, studentId,
function CreateMembership({ setOpen, open, fetchData, selectData, type }) {
  //   const isUpdate = type === "update";

  const auth = useRecoilValue(UserAuth.userState);

  const {
    control,
    reset,
    handleSubmit,
    formState: { errors },
    setValue,
    register,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: { ...initialState },
  });

  const resSuccess = (res) => {
    if (res?.status) {
      toast.success(res?.message);
      setOpen(false);
      reset();
      fetchData();
    }
  };

  const { manualRefresh } = useGetMemberByStudent({ studentId: selectData?.studentId });

  const { loading, run: runCreate } = useRequest(MembershipDB.add, {
    manual: true,
    onSuccess: (data) => {
      resSuccess(data);
      manualRefresh();
    },
  });

  const { loading: loadingUpdate, run: runUpdate } = useRequest(MembershipDB.update, {
    manual: true,
    onSuccess: (data) => {
      resSuccess(data);
      manualRefresh();
    },
  });

  useEffect(() => {
    if (!open) {
      reset();
    }
    function initData() {
      setValue("duration", { label: selectData?.duration, value: selectData?.duration } || null);
      setValue("expired_at", moment(selectData?.expired_at) || null);
    }

    if (type === "update") {
      initData();
    }
  }, [open]);

  const onSubmit = (data) => {
    // if (data?.studentId?.classType === "") {
    //   toast.warning("Warning! student has no class type.");
    //   return;
    // }

    // if (data?.studentId?.className === "") {
    //   toast.warning("Warning! student has no class.");
    //   return;
    // }

    const startDate = moment(data?.start_date).format("YYYY-MM-DD");

    if (type === "update") {
      runUpdate({
        ...data,
        student_id: selectData?.studentId,
        expire_at: convertDurationToExpireDate(startDate, data?.duration).format("YYYY-MM-DD"),
        date: moment(data?.date).format("YYYY-MM-DD"),
        start_date: moment(data?.start_date).format("YYYY-MM-DD"),
      });
    } else {
      runCreate({
        ...data,
        user_id: auth?.id,
        student_id: selectData?.studentId,
        expire_at: convertDurationToExpireDate(startDate, data?.duration).format("YYYY-MM-DD"),
        date: moment(data?.date).format("YYYY-MM-DD"),
        start_date: moment(data?.start_date).format("YYYY-MM-DD"),
      });
    }
  };

  return (
    <PrimaryModal
      open={open}
      setOpen={setOpen}
      title={
        <Grid container spacing={2}>
          <Grid item xs={10} sm={10} md={10} lg={10}>
            <Typography variant='h5' gutterBottom component='div'>
              <MembershipIcon
                size={30}
                className='membership-icon'
                style={{ color: "gray", backgroundColor: "White", borderRadius: 20 }}
              />{" "}
              {type === "update" ? "Update Membership" : "Add Membership"}
            </Typography>
            {/* <Typography variant='subtitle2' gutterBottom component='div'>
              Complete required field to add.
            </Typography> */}
          </Grid>

          <Grid item xs={2} sm={2} md={2} lg={2}>
            <Stack direction='row' justifyContent='flex-end' alignItems='center'>
              <IconButton color='error' onClick={() => setOpen(false)}>
                <IoCloseCircle />
              </IconButton>
            </Stack>
          </Grid>
        </Grid>
      }
    >
      <Grid container spacing={2}>
        {/* {!isUpdate ? (
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <SelectStudent
              name='studentId'
              disabled={!!studentId}
              control={control}
              required
              error={!!errors?.studentId}
              helperText={<span>{errors?.studentId?.message}</span>}
            />
          </Grid>
        ) : null} */}

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <TextField
            error={!!errors?.amount}
            helperText={<span>{errors?.amount?.message}</span>}
            style={{ width: "100%" }}
            // required
            size='small'
            label='Amount'
            type='number'
            {...register("amount")}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <ControllDatePicker
            name='date'
            control={control}
            required
            label='Date'
            minDate={moment()}
            error={!!errors?.date}
            helperText={<span>{errors?.date?.message}</span>}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <ControlSelect
            name='duration'
            control={control}
            required
            label='Duration period'
            error={!!errors?.duration}
            helperText={<span>{errors?.duration?.message}</span>}
            options={membershipDuration}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6}>
          <ControllDatePicker
            name='start_date'
            control={control}
            required
            label='Start date'
            minDate={moment()}
            error={!!errors?.start_date}
            helperText={<span>{errors?.start_date?.message}</span>}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6}>
          {/* <ControllDatePicker
            name='expire_at'
            control={control}
            required
            label='Expire Date'
            minDate={moment()}
            error={!!errors?.createdAt}
            helperText={<span>{errors?.createdAt?.message}</span>}
          /> */}

          <div>
            Expire date:{" "}
            {watch("duration") &&
              watch("start_date") &&
              convertDurationToExpireDate(
                moment(watch("start_date")).format("YYYY-MM-DD"),
                watch("duration")
              ).format("DD-MMM-YYYY")}
          </div>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <ControlSelect
            name='payment_method'
            control={control}
            required
            label='Payment method period'
            error={!!errors?.payment_method}
            helperText={<span>{errors?.payment_method?.message}</span>}
            options={membershipPaymentMethod}
          />
        </Grid>

        {/* <Grid item xs={12} sm={12} md={12} lg={12}>
          <TextField
            multiline
            rows={12}
            placeholder='description...'
            error={!!errors?.description}
            helperText={<span>{errors?.description?.message}</span>}
            style={{ width: "100%" }}
            size='small'
            label={null}
            {...register("description")}
          />
        </Grid> */}

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <LoadingButton
            style={{ width: "100%" }}
            className='ssc_text_field'
            size='small'
            variant='contained'
            disableElevation
            loading={loading || loadingUpdate}
            onClick={handleSubmit(onSubmit)}
          >
            {type === "update" ? "Update" : "Save"}
          </LoadingButton>
        </Grid>
      </Grid>
    </PrimaryModal>
  );
}

export default memo(CreateMembership);
